export default "__VITE_ASSET__CIzfiqKe__"